import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { ThemeProvider } from '@mui/material/styles';
import Theme from './Theme';
import Store from './Redux/Store';
import { Provider } from "react-redux"
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers';
import "./i18n";
import 'leaflet/dist/leaflet.css';
// import { DatePicker } from '@mui/x-date-pickers/DatePicker';

const addOmiseScript = () => {

  const scriptId = "omise-script";

  if (!document.getElementById(scriptId)) {
    const script = document.createElement("script");
    script.id = scriptId;
    script.src = "https://cdn.omise.co/omise.js";
    script.async = true;
    script.onload = () => {
      if (window.OmiseCard) {
        window.OmiseCard.configure({
          publicKey: process.env.REACT_APP_PAYMENT_KEY,
        });
      }
    };
    script.onerror = () => {
      console.error("Failed to load Omise.js");
    };
    document.body.appendChild(script);
  }
};

console.log(process.env.REACT_APP_PAYMENT_KEY)
  addOmiseScript()
  
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // <React.StrictMode>
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <Provider store={Store}>
        <ThemeProvider theme={Theme}>
          <App />
        </ThemeProvider>
      </Provider>
    </LocalizationProvider>
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
